import { Component } from '@angular/core';

@Component({
  selector: 'gom-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Game Of Marriage - Point Calculator';
}
